import { render, staticRenderFns } from "./GuoHe.vue?vue&type=template&id=0f0a06fa&scoped=true&"
import script from "./GuoHe.vue?vue&type=script&lang=js&"
export * from "./GuoHe.vue?vue&type=script&lang=js&"
import style0 from "./GuoHe.vue?vue&type=style&index=0&id=0f0a06fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0a06fa",
  null
  
)

export default component.exports